if (!customElements.get('yt-embed')) {
  class YouTubeEmbed extends HTMLElement {
    constructor() {
      super();
 
      this.player = this.querySelector('.js-youtube');        
      let parent = this.closest('eager-media');
      this.playButton = parent.querySelector('button');
      this.youtubePlayer = false;
 
      //event listener to prevent simultaneous video playback
      window.addEventListener('video-playing', this.videoPlayed.bind(this));

      //play event is wrapped in event handler to allow for proper event propagation on iOS devices
      this.playButton.addEventListener('click', () => { 
        if (this.youtubePlayer){      
          this.youtubePlayer.playVideo();               
        }
      });
    }

    connectedCallback() {
      window.addEventListener('yt-api-ready', this.createYoutubePlayer.bind(this));
    }

    videoPlayed(event){
      //if the current played video is not this video, pause this one if it is playing
      if (event.detail != this.getAttribute('video-id') && this.youtubePlayer.getPlayerState() == YT.PlayerState.PLAYING){
        this.youtubePlayer.pauseVideo();
      }
    }

    createYoutubePlayer(){
      this.youtubePlayer = new YT.Player(this.querySelector('iframe'), {
          videoId: this.getAttribute('video-id'),
          events: {
            'onStateChange': this.onPlayerStateChange.bind(this)
          }
      });     
    }

    onPlayerStateChange(event) {
     
      if (event.data == YT.PlayerState.ENDED) {
        //do a full stop on the video to prevent the related videos from appearing at the end
        this.youtubePlayer.stopVideo();
      } else if (event.data == YT.PlayerState.PLAYING) {
        //dispatch event to notify other videos that this one is now playing
        window.dispatchEvent(new CustomEvent("video-playing", { detail: this.getAttribute('video-id')} ));
      }
    }   
  }
  customElements.define('yt-embed', YouTubeEmbed);
}